<style scoped>
  @import url('https://fonts.googleapis.com/css?family=Roboto:400,500&display=swap');
  #quote-container{
    padding: 40px;
    border-radius: 0 0 8px 8px;
  }
  #quote{
    color: #787878;
    font-family: 'Roboto', sans-serif;
    font-size: 10pt;
    margin: 0 auto;
    min-height: 279mm;
    padding: 60pt 40pt;
    width: 216mm;
  }
  #quote b{
    color: #505050;
    font-weight: 500;
  }
  #logo-soluble{
    display: block;
    height: auto;
    margin: 0 auto 40pt;
    width: 40mm;
  }
  table{
    border-collapse: collapse;
    margin: 20pt 0;
    width: 100%;
  }
  table th, table td{
    vertical-align: top;
  }
  .general_color_style{
    color: #787878;
  }
  .general_color_style b{
    color: #505050;
    font-style: bold;
  }
  .link_styles{
    color: #FDDA24;
    font-style: bold;
    display: inline-block;
    margin-bottom: 1em;
  }
  .productos th, .productos td{
    color: #787878;
    padding: 10px;
  }
  .productos thead{
    background-color: rgb(245,245,245);
  }
  .productos thead th{
    color: #505050;
    font-size: 8pt;
    letter-spacing: 0.1em;
    text-transform: uppercase;
  }
  .productos tbody tr{
    border-bottom: solid 1px rgb(245,245,245);
  }
  .productos p{
    font-size: 8pt;
    margin-top: 0;
  }
  .productos b{
    color: #787878;
  }
  .productos tfoot strong{
    font-size: 8pt;
  }
  .productos small{
    font-size: 8.5pt;
  }
  .referencias{
    border-left: solid 4px #FDDA24;
    font-size: 8pt;
    margin: 20pt 0;
    padding: 5pt 20pt;
  }
  .referencias p{
    margin: 0;
  }
  .notas{
    font-size: 9pt;
  }
  .referencias h4, .notas h4{
    font-size: 9pt;
    color: #505050;
    text-transform: uppercase;
  }
  .referencias h4{
    margin-bottom: 10pt;
  }
  .referencias small{
    font-size: 8pt;
  }
  .notas h4{
    margin: 10pt 0;
  }
  .productos tbody td p, .notas p{
    white-space: pre-line;
    word-wrap: break-word;
  }
</style>
<template>
  <section class="layout">
    <div v-if="version.productos" class="container">
      {{get_subtotal}}
      <div class="row h-items-center" id="general-quote-container">
        <div class="col-12 box-container b-complementary" id="quote-container">
          <div class="box-container b-white" id="quote">
            <img src="@/assets/soluble.png" alt="" id="logo-soluble">
            <table class="t-left intro">
              <thead>
                <tr>
                  <th></th>
                  <th style="text-align: right;"></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <p>
                      <b>
                        {{version.ref_cliente.nombre}}
                      </b>
                      <br>
                      {{version.fecha_creacion.seconds | simpleFormatDate}}
                      <br>
                      {{version.cotizar}} / {{version.nombre_proyecto}}
                      <br>
                      Folio: {{make_folio(version.ref_cliente.nombre, version.folio)}}
                    </p>
                  </td>
                  <td style="text-align: right;">
                    <p>
                      <b>
                        Soluble.
                      </b>
                      <br>
                      Guadalajara, Jalisco.
                      <br>
                      www.soysoluble.com
                      <br>
                      331-774-2356
                    </p>
                  </td>
                </tr>
              </tbody>
            </table> 
            <table class="t-left productos">
              <thead>
                <tr>
                  <th style="width: 240pt;">SERVICIO</th>
                  <th style="width: 240pt;">Incluye</th>
                  <th style="text-align: right;">Costo(MXN)</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(producto, key) in version.productos">
                  <td>
                    <p>
                      <b v-if="producto.titulo">{{producto.titulo}}<br></b>
                      <small>{{producto.descripcion}}</small>
                    </p>
                  </td>
                  <td>
                    <p v-for="(incluir, key) in producto.incluye">
                      <b v-if="incluir.titulo">{{incluir.titulo}}: </b>{{incluir.descripcion}}
                    </p>
                  </td>
                  <td style="text-align: right;">
                    <p>
                      {{producto.precio | formatPrice}}
                    </p>
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <td></td>
                  <td style="text-align: right;">
                    <p>
                      Subtotal:
                      <br>
                      I.V.A:
                      <br>
                      <b>Total:</b>
                    </p>
                  </td>
                  <td style="text-align: right;">
                    <p>
                      {{subtotal | formatPrice}}
                      <br>
                      {{Number(subtotal) * 0.16 | formatPrice}}
                      <br>
                      <b>{{Number(subtotal) + Number((subtotal * 0.16)) | formatPrice}}</b>
                    </p>
                  </td>
                </tr>
              </tfoot>
            </table> 
            <p class="general_color_style">
              Tiempo estimado de entrega: <b>{{version.tiempo_entrega}} días hábiles</b> a partir de la entrega de información, accesos, brief y el 50% del costo del proyecto como anticipo. Cada día de atraso en entregas de información necesaria o revisiones de avances aplazará la entrega del proyecto.
            </p>
            <p class="general_color_style">
              La presente cotización se lleva a cabo el día <b>{{version.fecha_creacion.seconds | simpleFormatDate}}</b>, en donde se estima el costo por lo mencionado anteriormente en este documento, teniendo una validez de <b>15 días hábiles</b> a partir de dicha fecha.
            </p>
            <div v-if="version.referencias.length" class="referencias">
              <h4>
                <b>Referencia(s):</b>
              </h4>
              <p v-for="referencia in version.referencias">
                <a v-bind:href="referencia" target="_blank" class="link_styles">{{referencia}}</a>
              </p>
              <p>
                <small><b>Las referencias son ejemplificativas y no reflejan la cantidad de secciones, acciones, funciones o contenido de la web cotizada.</b></small>
              </p>
            </div>
            <div v-if="version.notas.length" class="notas">
              <h4>
                <b>Nota(s):</b>
              </h4>
              <p v-for="nota in version.notas">{{nota.contenido}}</p>
            </div>
          </div>
        </div>
        <div class="col-4 phone-c-6">
          <p class="t-center">
            <a href="#" class="btn b-secondary" v-on:click.prevent="goTo('/editVersion/'+$route.params.id+'/'+version.id)">Editar Versión</a>
          </p>
        </div>
        <div class="col-4 phone-c-6">
          <p class="t-center">
            <a href="#" class="btn b-primary" v-on:click.prevent="makePdf">Descargar PDF</a>
          </p>
        </div>
        <div class="col-4 phone-c-12">
          <p class="t-center">
            <a href="#" class="btn b-warn" v-on:click.prevent="deleteVersion(version.id)">Eliminar Versión</a>
          </p>
        </div>
      </div>
    </div>
    <div v-else class="container">
      <div class="row">
        <div class="col-12 box-container b-complementary" id="quote-container">
          <div class="box-container b-white" id="quote">
            <p>
              No se encontraron los campos requeridos en la cotización, puedes realizar las siguientes acciones: 
            </p>
            <p>
              <a href="#" class="btn b-secondary" v-on:click.prevent="goTo('/editVersion/'+$route.params.id+'/'+version.id)">Puedes editar esta versión</a>
              <a href="#" class="btn b-warn" v-on:click.prevent="deleteVersion(version.id)">Eliminar esta versión</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import router from '@/router'
import { db } from '@/firebase'
var pdfMake = require('pdfmake/build/pdfmake.js')
var pdfFonts = require('pdfmake/build/vfs_fonts.js')
pdfMake.vfs = pdfFonts.pdfMake.vfs
require('moment/locale/es')
import moment from 'moment'
export default {
  name: 'GetContentQuote',
  components: {
    moment
  },
  props: {
    version: {
      required: true
    }
  },
  data (){
    return{
      subtotal: 0
    }
  },
  computed: {
    get_subtotal: function(){
      this.subtotal = 0
      for(const i in this.version.productos){
        this.subtotal += Number(this.version.productos[i].precio)
      }
      return ''
    }
  },
  methods: {
    goTo (url){
      router.replace({path: url})
    },
    deleteVersion (id){
      if(window.confirm('¿Estás Seguro? Esto eliminará esta versión')){
        var vm = this
        db.collection('cotizaciones').doc(vm.$route.params.id).collection('versiones').doc(id).delete().then(function() {

          //Obtener informacion de ultima version disponible
          db.collection('cotizaciones').doc(vm.$route.params.id).collection('versiones').orderBy('fecha_modificacion', 'desc').limit(1)
          .get()
          .then(function(querySnapshot) {
              querySnapshot.forEach(function(doc) {
                  if(doc.exists){
                    //Asignar valores de ersion mas reciente
                    let datos_version = doc.data()
                    // Actializar datos de cotizacion con informacion de una version anterior
                    db.collection('cotizaciones').doc(vm.$route.params.id).update(datos_version)
                    .then(function() {
                        //Actualizado
                        console.log('Document successfully deleted!')
                        router.replace('/quotes/')
                    })
                    .catch(function(error) {
                        //Error
                        alert('Error al actualizar la informacion de la cotizacion con la informacion de la version mas reciente revisa la consola para mas detalles')
                        console.error('Error removing document: ', error)
                    })
                  }
              })
          })
          .catch(function(error) {
              //Error
              console.log('No se encontro otra version' + error)
          })
  
        }).catch(function(error) {
          alert('Error al eliminar la version revisa la consola para mas detalles')
          console.error('Error removing document: ', error)
        })
      }
    },
    makePdf: function(){
      //
      var altura_cotizacion_px = document.getElementById("quote").offsetHeight + 80;
      var altura_cotizacion_pt = (altura_cotizacion_px * 3) / 4;
      var ancho_cotizacion_px = document.getElementById("quote").offsetWidth;
      var ancho_cotizacion_pt = (ancho_cotizacion_px * 3) / 4;

      //Header tabla
      const contenido_tabla_productos = [];
      contenido_tabla_productos.push([
        {
          border: [false, false, false, false],
          fillColor: '#F5F5F5',
          text: 'SERVICIO',
          style: 'table_header_style'
        },
        {
          border: [false, false, false, false],
          fillColor: '#F5F5F5',
          text: 'INCLUYE',
          style: 'table_header_style'
        },
        {
          border: [false, false, false, false],
          fillColor: '#F5F5F5',
          text: 'COSTO(MXN)',
          style: 'table_header_style',
          alignment: 'right'
        }
      ]);

      //Contenido Tabla
      for(const turn in this.version.productos){
        var contenido_incluye = [];
        for(const step in this.version.productos[turn].incluye){
          contenido_incluye.push(
            {
              text: this.version.productos[turn].incluye[step].titulo+': ',
              style: 'bold_color_style'
            },
            this.version.productos[turn].incluye[step].descripcion+'\n\n',
          );
        }
        contenido_tabla_productos.push([
          {
            border: [false, false, false, true],
            text: [
              {
                text: this.version.productos[turn].titulo+'\n',
                style: 'bold_color_style'
              },
              this.version.productos[turn].descripcion+'\n\n',
            ],
          },
          {
            border: [false, false, false, true],
            text: contenido_incluye,
          },
          {
            border: [false, false, false, true],
            text: this.$options.filters.formatPrice(this.version.productos[turn].precio),
            alignment: 'right'
          }
        ]);
      }

      //Pie Tabla
      contenido_tabla_productos.push(
        [
          {
            text: '',
          },
          {
            text: [
              'SUBTOTAL'+'\n',
              'I.V.A.'+'\n',
              {
                text: 'TOTAL',
                style: 'bold_color_style',
              }
            ],
            alignment: 'right'
          },
          {
            text: [
              this.$options.filters.formatPrice(Number(this.subtotal))+'\n',
              this.$options.filters.formatPrice(Number(this.subtotal) * 0.16)+'\n',
              {
                text: this.$options.filters.formatPrice(Number(this.subtotal) + Number((this.subtotal * 0.16))),
                style: 'bold_color_style',
              }
            ],
            alignment: 'right'
          }
        ],
      );

      //Contenido referencias
      var contenido_referencias = [];

      if(this.version.referencias.length){
        //Titulo Referencia
        contenido_referencias.push(
          [{
            border: [true, false, false, false],
            text: 'REFERENCIA(S):',
            style: 'bold_color_style',
          }]
        );
        //Referencias
        for(const turn in this.version.referencias){
          contenido_referencias.push(
            [{
              border: [true, false, false, false],
              text: [
                {
                  text: this.version.referencias[turn]+'\n',
                  style: 'link_style',
                },
              ],
            }]
          );
        }
        //Nota Referencias
        contenido_referencias.push(
          [{
            border: [true, false, false, false],
            text: 'Las referencias son ejemplificativas y no reflejan la cantidad de secciones, acciones, funciones o contenido de la web cotizada.',
            fontSize: 8,
            style: 'bold_style',
          }]
        );
      }else{
        //Contenido vacio de tabla en caso de no existir referencia
        contenido_referencias.push(
          [{
            border: [false, false, false, false],
            text: '',
          }]
        );
      }

      //Contenido notas
      var contenido_notas = [];

      if(this.version.notas.length){
        //Titulo Notas
        contenido_notas.push(
          {
            text: [
                {
                  text: 'NOTA(S): \n\n',
                  style: 'bold_color_style',
                  fontSize: 9,
                },
            ],
            margin: [0, 10, 0, 10],
            headlineLevel: 1
          }
        );
        //Notas
        for(const turn in this.version.notas){
          contenido_notas.push(
            {
              text: [
                  {
                    text: this.version.notas[turn].contenido+'\n\n',
                    style: 'general_color_style',
                    fontSize: 9,
                  },
              ],
              headlineLevel: 1
            }
          );
        }
      }

      var docDefinition = {

        pageSize: { width: ancho_cotizacion_pt, height: altura_cotizacion_pt },

        pageOrientation: 'portrait',

        pageMargins: [ 40, 60, 40, 60 ],

        //header: function(currentPage, pageCount) { 
        //  return {
        //    text: 'Soluble. Conectar para crear.', 
        //    alignment: 'center',
        //    style: 'water_mark_style',
        //    margin: [ 0, 20, 0, 20 ],
        //  } 
        //},

        footer: function(currentPage, pageCount) { 
          return {
            text: 'Soluble. Conectar para crear. '/* + currentPage.toString() + ' de ' + pageCount*/, 
            alignment: 'center',
            style: 'water_mark_style',
            margin: [ 0, 20, 0, 20 ],
          } 
        },

        content: [
            {
              image: 'data:image/png;base64,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',
              width: (152 * 3) / 4,
              alignment: 'center',
              margin: [0,0,0,60]
            },
            {
              columns: [
                {
                  text: [
                    {
                      text: this.version.ref_cliente.nombre+'\n', 
                      style: 'bold_style'
                    },
                    this.$options.filters.simpleFormatDate(this.version.fecha_creacion.seconds)+'\n',
                    this.version.cotizar+' / '+this.version.nombre_proyecto+'\n',
                    'Folio: '+this.make_folio(this.version.ref_cliente.nombre, this.version.folio)
                  ],
                  style: 'general_color_style',
                },
                {
                  text: [
                    {
                      text: 'Soluble.\n', 
                      style: 'bold_style'
                    },
                    'Guadalajara, Jalisco.\n',
                    'www.soysoluble.com\n',
                    '331-774-2356'
                  ],
                  style: 'general_color_style',
                  alignment: 'right',
                }
              ]
            },
            {
              style: 'table_general_style',
              table: {
                headerRows: 1,
                // dontBreakRows: true,
                // keepWithHeaderRows: 1,
                widths: [200, 200, '*'],
                body: contenido_tabla_productos
              },
              layout: {
                defaultBorder: false,
                hLineWidth: function (i, node) {
                  return (i === 0 || i === node.table.body.length) ? 0.5 : 0.5;
                },
                hLineColor: function (i, node) {
                  return (i === 0 || i === node.table.body.length) ? '#F5F5F5' : '#F5F5F5';
                },
                paddingLeft: function(i, node) { return 10; },
                paddingRight: function(i, node) { return 10; },
                paddingTop: function(i, node) { return 10; },
                paddingBottom: function(i, node) { return 10; },
              }
            },
            {
              text: [
                  {
                    text: 'Tiempo estimado de entrega: ',
                    style: 'general_color_style'
                  },
                  {
                    text: this.version.tiempo_entrega+' días hábiles',
                    style: 'bold_color_style'
                  },
                  {
                    text: ' a partir de la entrega de información, accesos, brief y el 50% del costo del proyecto como anticipo. Cada día de atraso en entregas de información necesaria o revisiones de avances aplazará la entrega del proyecto.\n\n',
                    style: 'general_color_style'
                  },
              ],
              headlineLevel: 1
            },
            {
              text: [
                  {
                    text: 'La presente cotización se lleva a cabo el día ',
                    style: 'general_color_style'
                  },
                  {
                    text: this.$options.filters.simpleFormatDate(this.version.fecha_creacion.seconds),
                    style: 'bold_color_style'
                  },
                  {
                    text: ' en donde se estima el costo por lo mencionado anteriormente en este documento, teniendo una validez de',
                    style: 'general_color_style'
                  },
                  {
                    text: ' 15 días hábiles',
                    style: 'bold_color_style'
                  },
                  {
                    text: ' a partir de dicha fecha.',
                    style: 'general_color_style'
                  },
              ],
              headlineLevel: 1
            },
            {
              style: 'table_general_style',
              table: {
                body: contenido_referencias
              },
              layout: {
                defaultBorder: false,
                vLineWidth: function (i, node) {
                  return (i === 0 || i === node.table.body.length) ? 4 : 4;
                },
                vLineColor: function (i, node) {
                  return (i === 0 || i === node.table.body.length) ? '#FDDA24' : '#FDDA24';
                },
                paddingLeft: function(i, node) { return 20; },
                paddingRight: function(i, node) { return 20; },
                paddingTop: function(i, node) { return 5; },
                paddingBottom: function(i, node) { return 5; },
              },
              headlineLevel: 1
            },
            {
              text: contenido_notas
            },
          ],
          pageBreakBefore: function(currentNode, followingNodesOnPage, nodesOnNextPage, previousNodesOnPage) {
            return currentNode.headlineLevel === 1 && followingNodesOnPage.length === 0;  
          },
          styles: {
            bold_style: {
              bold: true,
              color: '#505050'
            },
            link_style: {
              bold: true,
              color: '#FDDA24'
            },
            bold_color_style: {
              bold: true,
              color: '#505050'
            },
            table_header_style: {
              bold: true,
              color: '#505050',
              fontSize: 8
            },
            general_color_style: {
              color: '#787878',
            },
            table_general_style: {
              margin: [0, 20, 0, 20],
              color: '#787878',
              fontSize: 8
            },
            water_mark_style: {
              color: '#787878',
              fontSize: 8
            }
          },
          defaultStyle: {
            columnGap: 20,
            color: '#505050',
            fontSize: 10
          }
      }
      const curdate = new Date(this.version.fecha_modificacion.seconds * 1000)
      const momentdate = curdate.toISOString()
      var creacion = moment(momentdate).format('MMMM-DD-YYYY')
      var fullName = creacion + ' ' +this.version.cotizar + ' ' + this.version.nombre_proyecto + ' By Soluble. ' + ' ' + this.version.folio
      var makeName = this.slugy(fullName) + '.pdf'
      console.log(makeName)
      pdfMake.createPdf(docDefinition).download(makeName)
    },
    make_folio: function(name, fol){
      if(name){
        var the_name = name.substr(0, 6);
        return (the_name+'-'+fol).toUpperCase();
      }else{
        return ''
      }
    },
    slugy: function slugify(string) {
      const a = 'àáäâãåèéëêìíïîòóöôùúüûñçßÿœæŕśńṕẃǵǹḿǘẍźḧ·/_,:;'
      const b = 'aaaaaaeeeeiiiioooouuuuncsyoarsnpwgnmuxzh------'
      const p = new RegExp(a.split('').join('|'), 'g')

      return string.toString().toLowerCase()
        .replace(/\s+/g, '-') // Replace spaces with
        .replace(p, c => b.charAt(a.indexOf(c))) // Replace special characters
        .replace(/&/g, '-and-') // Replace & with ‘and’
        .replace(/[^\w\-]+/g, '') // Remove all non-word characters
        .replace(/\-\-+/g, '-') // Replace multiple — with single -
        .replace(/^-+/, '') // Trim — from start of text .replace(/-+$/, '') // Trim — from end of text
    }
  }
}
</script>
